import { formatISO } from 'date-fns';
import axiosInstance from './config/api';

export type GetLiveMonitorStatsParams = {
    id: string;
    /** Optional call direction filter (OUTBOUND / INBOUND / MANUAL). */
    callDirection?: string;
};

export type LiveMonitorStatsResponse = {
    activeCalls: number;
    queued: number;
    pending: number;
    avgDurationSeconds: number;
};

/**
 * Lightweight Live Monitor bar metrics.
 * `now` is sent as RFC3339 with local offset so the BE can scope avg duration
 * to the calendar day in the client's timezone.
 */
export const getLiveMonitorStats = ({ id, callDirection }: GetLiveMonitorStatsParams) => {
    return axiosInstance
        .get<LiveMonitorStatsResponse>(`/workflows/${id}/live-monitor/stats`, {
            params: {
                now: formatISO(new Date()),
                ...(callDirection ? { callDirection } : {}),
            },
        })
        .then((res) => res.data);
};
